export default {"src":"/planos/_next/static/media/equifax-purchase.ab95e25b.svg","height":33,"width":42,"blurWidth":0,"blurHeight":0};